import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
    selector: 'app-loading-button',
    templateUrl: './loading-button.component.html',
    styleUrls: ['./loading-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoadingButtonComponent {
  @Input() public cssClass: string;
  @Input() public isLoading = false;
  @Input() public disabled = false;
  @Input() public disableRipple = false;
  @Input() public showArrow = false;
  @Input() public loadingClass: string;
  @Input() public progress = 0;
  @Input() public enableProgressIndicator = false;
  @Input() dataCy = '';

  @Output() public clicked: EventEmitter<Event> = new EventEmitter<Event>();

  @HostBinding('attr.data-cy') @Input() dataAttribute: string;

  constructor() { }

  public clickHandler(event: Event): void {
    if (this.isLoading || this.disabled) {
      return;
    }

    this.clicked.emit(event);
  }

}
